import { PayoutSetupStatus } from "@fp/admin-api-client/types/payoutSetupStatus.js";

export type PayoutReadiness = "ready" | "notReady";

export const payoutReadinessByStatus: Record<PayoutSetupStatus, PayoutReadiness> = {
  [PayoutSetupStatus.OrganizationRelationshipNeeded]: "notReady",
  [PayoutSetupStatus.NotStarted]: "notReady",
  [PayoutSetupStatus.IdentityVerificationPending]: "notReady",
  [PayoutSetupStatus.PayoutMethodNeeded]: "notReady",
  [PayoutSetupStatus.BankAccountAwaitingReview]: "notReady",
  [PayoutSetupStatus.BankAccountRejected]: "notReady",
  [PayoutSetupStatus.BankAccountUnlinked]: "notReady",
  [PayoutSetupStatus.BankAccountReturned]: "notReady",
  [PayoutSetupStatus.DebitCardNotPayoutEligible]: "notReady",
  [PayoutSetupStatus.DebitCardPayoutsUnavailable]: "notReady",
  [PayoutSetupStatus.Ready]: "ready",
};
